// USPS abbreviation -> full state name (used by the State Spotlight tally).
export const STATE_NAMES = {
  AL: "Alabama", AZ: "Arizona", CA: "California", CO: "Colorado", CT: "Connecticut",
  DC: "Washington, D.C.", DE: "Delaware", FL: "Florida", GA: "Georgia", IA: "Iowa",
  IL: "Illinois", IN: "Indiana", KS: "Kansas", KY: "Kentucky", LA: "Louisiana",
  MA: "Massachusetts", MD: "Maryland", MI: "Michigan", MN: "Minnesota", MO: "Missouri",
  NC: "North Carolina", NE: "Nebraska", NH: "New Hampshire", NJ: "New Jersey",
  NY: "New York", OH: "Ohio", OR: "Oregon", PA: "Pennsylvania", RI: "Rhode Island",
  SC: "South Carolina", TN: "Tennessee", TX: "Texas", UT: "Utah", VA: "Virginia",
  WA: "Washington", WI: "Wisconsin",
};

export const stateName = (abbr) => STATE_NAMES[abbr] || abbr;
